import { Control } from '../../../../vas/business-objects/control/control.model';
import { ComplexControl } from '../../../../vas/controls/complex/complex-control.model';
import { CONTROL_TYPES } from '../../../../vas/controls/control-types';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const subControlFormLoadReducer = (
    state = initialState,
    action: actions.SubControlFormLoad
): State => {
    return {
        ...state,
        subControlForm: (() => {

            const controlId = action.payload.controlId;
            const accountId = action.payload.accountId;
            const subControlId = action.payload.subControlId;

            const control = state.controlForm.control;

            if (!control) {
                return {
                    control: undefined,
                    subControl: undefined
                };
            }

            let subControl;

            // if the subControlId is undefined we're creating a new
            // sub control otherwise we should go and find the instance
            // from the parent control
            if (subControlId) {
                subControl = (control as ComplexControl).config.controls
                    .find(c => c.id === subControlId);
            }

            // if the subControl is undefined, either because the
            // subControlId was undefined or because we didn't find it,
            // create a new instance so we can edit it
            if (!subControl) {
                return {
                    control,
                    subControl: new Control({
                        account: accountId,
                        controlType: state.controlType.ids
                            .map(id => state.controlType.entities[id])
                            .find(ct => ct.name === CONTROL_TYPES.TEXT)
                            .id
                    })
                };
            }

            return {
                control,
                subControl
            };
        })()
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/sub-control-form-load.reducer.ts